module.exports = __webpack_public_path__ + "images/feature/20190524-7dbb1635c28a0c35cf45593163553d0b.png";